import { useMutation, useQueryClient } from '@tanstack/react-query'
import { bulkDeleteServiceAreaOverrideRules } from '../../../api/plan-service-area-override-rules-api'
import type { BulkDeleteServiceAreaOverrideRulesRequestDto } from '../../../api/dto/plan-service-area-override-rules.dto'
import { SERVICE_AREA_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanServiceAreaOverride/hooks/useGetServiceAreaOverrideRules'

export function useBulkDeleteServiceAreaOverrideRules() {
  const queryClient = useQueryClient()

  return useMutation<
    void,
    unknown,
    BulkDeleteServiceAreaOverrideRulesRequestDto
  >({
    mutationFn: (body) => bulkDeleteServiceAreaOverrideRules(body),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [SERVICE_AREA_OVERRIDE_RULES_QUERY_KEY],
      })
    },
  })
}
